import {
defineCustomElement,
MediaMenuElement,
MediaMenuItemsElement
} from "vidstack/elements";

defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuItemsElement);